import { query_shop_operation_list } from '@/api/mjstat-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstat/mjstat-shop_operation_daily_report-config';

import { reactive } from 'vue';
import moment from 'moment';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY);

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'rangepicker',
      name: 'date_interval',
      label: '运营日期',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      showTime: false,
      valueFormat: 'YYYY-MM-DD',
      placeholder: '请选择运营日期',
    },
  ],
  rules: {
    date_interval: [
      { required: true, message: '请输入运营日期', type: 'array' },
      {
        validator: (rule: any, value: any, callback: any) => {
          return new Promise((resolve: any, reject: any) => {
            if (value instanceof Array && value.length == 2) {
              if (value[0].substring(8) != '01') {
                callback();
                reject('开始日期必须选择当月1号');
              } else if (value[0].substring(5, 7) != value[1].substring(5, 7)) {
                callback();
                reject('日期不允许跨月');
              } else {
                callback();
                resolve();
              }
            }
          });
        },
        trigger: 'change',
      },
    ],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    date_interval: [moment().format('YYYY-MM-01'), moment().format('YYYY-MM-01')],
    shop_id: null,
    pageSize: 5000,
  }),
};
const search_options = {};

const edit_model_config = {};
const edit_model_config_options = {};

const update_model_config = {};
const update_model_config_options = {};

const titleList = {
  title: '店务运营日报表',
  addModalTitle: '新建店务运营日报表',
  updateTitle: '编辑店务运营日报表',
  is_create: false, // 是否有【新建】按钮
  is_update: false, // 是否有【修改】按钮
  is_remove: false, // 是否有【删除】按钮
  is_recover: false, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    id: 'id',
  },
  delete: {
    id: 'id',
  },
  recover: {
    id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
  },
  {
    title: '门店编码',
    dataIndex: 'shop_code',
    width: 100,
  },
  {
    title: '门店名称',
    width: 120,
    dataIndex: 'shop_name',
    checked: true,
  },
  {
    title: '今日护理数',
    width: 120,
    dataIndex: 'nursing_count_today',
    checked: true,
  },
  {
    title: '护理目标数',
    width: 120,
    dataIndex: 'target_nursing_count',
    checked: true,
  },
  {
    title: '护理完成数',
    width: 120,
    dataIndex: 'nursing_count',
    checked: true,
  },
  {
    title: '护理数达成比',
    width: 120,
    dataIndex: 'nursing_count_percent',
    checked: true,
  },
  {
    title: '护理目标额',
    width: 120,
    dataIndex: 'target_nursing_price',
    checked: true,
  },
  {
    title: '护理完成额',
    width: 120,
    dataIndex: 'nursing_price',
    checked: true,
  },
  {
    title: '护理达成比',
    width: 120,
    dataIndex: 'nursing_price_percent',
    checked: true,
  },
  {
    title: '产品目标额',
    width: 120,
    dataIndex: 'target_product_price',
    checked: true,
  },
  {
    title: '产品完成额',
    width: 120,
    dataIndex: 'product_price',
    checked: true,
  },
  {
    title: '产品达成比',
    width: 120,
    dataIndex: 'product_price_percent',
    checked: true,
  },
  {
    title: '消费目标额',
    width: 120,
    dataIndex: 'target_total_price',
    checked: true,
  },
  {
    title: '消费完成额',
    width: 120,
    dataIndex: 'total_price',
    checked: true,
  },
  {
    title: '消费达成比',
    width: 120,
    dataIndex: 'total_price_percent',
    checked: true,
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
// newSlotList.push({
//   type: 'custom',
//   // slotName: 'is_active',
//   field_true: '可用',
//   field_false: '作废',
// });

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_shop_operation_list,
    addData: null,
    updateData: null,
    removeData: null,
    recoverData: null,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
    rowKey: '_index',
  };
};
